export default {
    getLanguage() {
        return localStorage.getItem('language') || 'tc';
    },
    setLanguage(language) {
        localStorage.setItem('language', language);
    }
}